import { render, staticRenderFns } from "./PersonalCardDialog.vue?vue&type=template&id=1ed882ea&scoped=true"
import script from "./PersonalCardDialog.vue?vue&type=script&lang=js"
export * from "./PersonalCardDialog.vue?vue&type=script&lang=js"
import style0 from "./PersonalCardDialog.vue?vue&type=style&index=0&id=1ed882ea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ed882ea",
  null
  
)

export default component.exports